'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _isObject2 = require('lodash/isObject');

var _isObject3 = _interopRequireDefault(_isObject2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildIconInfo(icon) {
  var defaultIcon = { symbol: 'link' };
  if ((0, _isString3.default)(icon)) return _extends({}, defaultIcon, { symbol: icon, hidden: true });
  if ((0, _isObject3.default)(icon)) return _extends({}, defaultIcon, icon);
  return defaultIcon;
}
function getIcon(icon) {
  return (0, _react.createElement)(_Icon2.default, buildIconInfo(icon));
}

// You can send it an icon or a name or both.
function LinkContent(_ref) {
  var children = _ref.children,
      defaultName = _ref.defaultName,
      icon = _ref.icon,
      name = _ref.name;

  // If there is children and it's not a string render it.
  if (children && !(0, _isString3.default)(children)) return children;
  // Assume children is string or undefined.
  var text = children || name;
  if (text && !icon) return _react2.default.createElement(
    'span',
    null,
    text
  );
  if (!text && icon) return getIcon(icon);
  if (icon && text) {
    return (0, _react.createElement)('span', null, getIcon(icon), (0, _react.createElement)('span', null, text));
  }
  return _react2.default.createElement(
    'span',
    null,
    defaultName
  );
}
LinkContent.defaultProps = {
  defaultName: 'Click here'
};
LinkContent.propTypes = {
  children: _propTypes2.default.node,
  defaultName: _propTypes2.default.string.isRequired,
  icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  name: _propTypes2.default.string
};
exports.default = LinkContent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/Link/LinkContent.js
// module id = 688
// module chunks = 0